import api from '@/utils/httpClient';
import { useMutation } from 'react-query';

function submitRequest(id: string) {
  return api.patch(`/api/collaborationrequests/${id}/submit`);
}

interface ResponseToRequestParameters {
	id: string;
}

function useSubmitRequest() {
  return useMutation(({ id }: ResponseToRequestParameters) => submitRequest(id));
}

export { useSubmitRequest, submitRequest };
